import {
  MODE_FILTER_SUCCESS,
  MODE_CREATE_SUCCESS,
  MODE_LIST_SUCCESS,
  MODE_INFO_SUCCESS,
  MODE_UPDATE_SUCCESS,
  MODE_DELETE_SUCCESS,
  MODE_FILTER_HANDLING,
  MODE_SEARCH_NAME,
  CLEAR_MODE_INFO,
  MODE_LIST,
} from "../actionTypes/mode";
import {
  ON_SHOW_MESSAGE,
  INIT_URL,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  HIDE_DIALOG,
} from "../actionTypes/common";
import { userSignOut } from "./auth";
// import AllDataService from '../services/all.service';

import axiosHttp from "../services/axiosCommon";

// export const getCoursetypeFilter = () => async (dispatch) => {
//   try {
//     const promises = [
//       axiosHttp.get("/v1/filtration"),
//       axiosHttp.get("/v1/affiliationFilter"),
//       axiosHttp.get("/v1/coursetypeTypeFilter"),
//       axiosHttp.get("/v1/coursetypeFilter"),
//     ];

//     const response = await Promise.all(promises);
//     const results = response.map((res) => res.data.status && res.data.results);
//     console.log({ results });
//     if (results.length === 0) {
//       dispatch({
//         type: ON_SHOW_MESSAGE,
//         payload: {
//           message: "Some error has occurred",
//           status: 500,
//           error: true,
//         },
//       });
//     } else {
//       dispatch({
//         type: ON_HIDE_LOADER,
//       });
//       dispatch({
//         type: COURSETYPE_FILTER_SUCCESS,
//         payload: {
//           ...results[0]["data"],
//           ...results[1]["data"],
//           ...results[2]["data"],
//           ...results[3]["data"],
//         },
//       });
//     }
//   } catch (err) {
//     const { response } = err;
//     if (response && response.status === 401) {
//     } else {
//       dispatch({
//         type: ON_SHOW_MESSAGE,
//         payload: {
//           message: "Some error has occurred",
//           status: 500,
//           error: true,
//         },
//       });
//     }
//     return Promise.reject(err);
//   }
// };
// export const getCourseFilter = () => async (dispatch) => {
//   try {
//     const result = await axiosHttp.get("/v1/filtration");
//     const { data } = result;
//     if (!data.status) {
//       dispatch({
//         type: ON_SHOW_MESSAGE,
//         payload: data,
//       });
//     } else {
//       dispatch({
//         type: COURSE_FILTER_SUCCESS,
//         payload: data.results,
//       });
//     }

//     return Promise.resolve(data);
//   } catch (err) {
//     const { response } = err;
//     if (response && response.status === 401) {
//     } else {
//       dispatch({
//         type: ON_SHOW_MESSAGE,
//         payload: {
//           message: "Some error has occurred",
//           status: 500,
//           error: true,
//         },
//       });
//     }
//     return Promise.reject(err);
//   }
// };

export const getMode = (paramsObj) => async (dispatch) => {
  try {
    const result = await axiosHttp.get("/mode/list", {
      params: paramsObj,
    });
    const { data } = result;
    if (data.error) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    } else {
      dispatch({
        type: MODE_LIST,
        payload: data.data,
      });
    }

    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};
export const getModeList = (queryInfo) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const result = await axiosHttp.get("/v1/mode", {
      params: queryInfo,
    });
    const { data } = result;
    console.log({ responceData: data });
    if (!data.status && data.code !== 200) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    } else {
      dispatch({
        type: INIT_URL,
        payload: "/mode/list",
      });
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      dispatch({
        type: MODE_LIST_SUCCESS,
        payload: { data: data.results, queryInfo },
      });
    }

    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};
export const getModeInfo = (modeId) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const result = await axiosHttp.get("/v1/mode/" + modeId);
    const { data } = result;
    if (!data.status) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    } else {
      dispatch({
        type: ON_HIDE_LOADER,
      });
      // dispatch({
      //   type: COURSE_INFO_SUCCESS,
      //   payload: data,
      // });

      dispatch({
        type: MODE_INFO_SUCCESS,
        payload: data.results,
      });
    }

    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      // dispatch(
      //   userSignOut({
      //     changeMessage: true,
      //     payload: {
      //       message: response.data.message,
      //       status: response.status,
      //       error: true,
      //     },
      //   })
      // );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          message: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};
export const setModeInfo = (info) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  dispatch({
    type: MODE_INFO_SUCCESS,
    payload: info,
  });
};
export const createMode = (infoData) => async (dispatch) => {
  console.log({ infoData });
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const result = await axiosHttp.post("/v1/mode", infoData);
    const { data } = result;
    if (!data.status) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      return Promise.reject(data);
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      return Promise.resolve(data);
    }
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const updateMode = (infoData) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const result = await axiosHttp.put("/v1/mode", infoData);
    const { data } = result;
    if (!data.status) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      return Promise.reject(data);
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      return Promise.resolve(infoData);
    }
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};
export const deleteMode = (infoData) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const { id } = infoData;
    console.log({ id, infoData });
    // const result = await axiosHttp.delete("/v1/courseType", {
    //   courseTypeId: courseTypeId,
    // });
    const result = await axiosHttp.delete("/v1/mode", { data: infoData });
    const { data } = result;
    if (!data.status) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      return Promise.reject(data);
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      return Promise.resolve(data);
    }
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const onChangeSearchName = (info) => async (dispatch) => {
  dispatch({
    type: MODE_SEARCH_NAME,
    payload: info,
  });
};

export const onChangeFilterHandling = (info) => async (dispatch) => {
  dispatch({
    type: MODE_FILTER_HANDLING,
    payload: info,
  });
};
export const clearModeInfo = () => async (dispatch) => {
  dispatch({
    type: CLEAR_MODE_INFO,
  });
};
